module.exports = __webpack_public_path__ + "img/supplier-premium-vip-bg.5c14960d.png";